/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { memo, useState, } from 'react';
import { useQuery, } from 'react-query';

import {
  AddButton,
  BasicTable,
  HeaderSide,
  Loader,
  PageContainer,
  PersonAddAlt1OutlinedIcon,
  Popup,
  SearchBar,
} from '../../components';

import { CustomerEntity, CustomersResponse, DataColumn, } from '../../types';

import { CustomerDelete, } from './customerDelete/CustomerDelete';

import { CONFIG, } from '../../utils/config';

import './Customers.css';

/* ------------ Powiązanie nagłówka tabeli z danymi -------- */

const columns: DataColumn[] = [
  {
    name: 'Nazwa',
    data: 'name',
  },
  {
    name: 'NIP',
    data: 'NIP',
  },
  {
    name: 'REGON',
    data: 'REGON',
  },

  {
    name: 'Miasto',
    data: 'city',
  },
];
export const Customers = memo(() => {

  /* ------------ Logika wyszukiwania klientów -------- */
  // wyszukiwarka
  const [ search, setSearch, ] = useState<string>('');

  // id usuwanego
  const [ idDelete, setIdDelete, ] = useState<string>('');

  // aktywny popup
  const [ popup, setPopup, ] = useState<boolean>(false);

  /* ------------ Pobieranie wszytkach klientów -------- */
  const {
    isLoading,
    isError,
    data: customers,
  } = useQuery(
    'customers', async (): Promise<CustomerEntity[]> => {
      const res: Response = await fetch(
        `${CONFIG.URL}/api/customer`, {
          credentials: 'include',
        }
      );
      const { data, }: CustomersResponse = await res.json();
      return data;
    }
  );

  /* ------------ Renderowanie Loader i Błędu -------- */
  if (isLoading) return <Loader />;

  if (isError) return <p>Wystąpił nieoczekiwany błąd...</p>;

  /* ------------ Renderowanie Widoku -------- */
  return (
    <main className='contractView'>
      <PageContainer>
        <HeaderSide
          title='Klienci'
          icon={<PersonAddAlt1OutlinedIcon />}
          button={<AddButton
            text='Dodaj nowy'
            action='new'
          />}
        />
        <SearchBar handleSearch={setSearch} search={search} />
        {customers && (
          <BasicTable
            dataColumns={columns}
            dataRows={customers}
            viewPopup={setPopup}
            popup={popup}
            setIdDelete={setIdDelete}
            search={search}
          />
        )}
      </PageContainer>
      {popup && idDelete && <Popup viewPopup={setPopup} >
        <CustomerDelete id={idDelete} viewPopup={setPopup}/>
      </Popup>}
    </main>
  );
});
